module.exports = __webpack_public_path__ + "img/ccia.3cc87679.png";